// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__KTiw_","heading":"styles_heading__FjIAE","icons":"styles_icons__r0wGG"};